module.exports = __webpack_public_path__ + "fonts/07d5c9e793599811873ff699c36b86c5.eot";